import { VOCABULARY_TYPE_CONFIG } from '../../../types/api';
/**
 * All input-type values from `SubfieldDef.inputType`. Keep in sync with the
 * literal union in `fieldDefinitionTypes.ts` (the exhaustiveness assertion
 * below fails to typecheck if they drift).
 *
 * `multi-record-picker` (CZNA-214) is the dedicated value for multi-value
 * AUTHORITY subfields; `multi-vocabulary` is reserved for multi-value
 * VOCABULARY subfields. `multi-text` is the free-text chip list (TASK-110),
 * `multi-textarea` its multi-line twin (CZNA-1646).
 */
export var INPUT_TYPES = [
    'text',
    'textarea',
    'select',
    'combobox',
    'vocabulary',
    'record-picker',
    'multi-vocabulary',
    'multi-record-picker',
    'multi-text',
    'multi-textarea',
];
// Reference the assertion variable so eslint's no-unused-vars is satisfied
// while the compile-time check still runs.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var _inputTypesExhaustive = true;
/**
 * Subset of `INPUT_TYPES` exposed in the visual editor property-panel
 * dropdown. `select` and `combobox` are intentionally omitted:
 *
 *   1. Both require an out-of-band `selectOptions` array on the
 *      `SubfieldDef`; the visual editor has no UI for editing that
 *      array, so picking either option silently degrades to a plain
 *      text fallback in the renderer (`if (sf.inputType === 'select'
 *      && sf.selectOptions)` is false → text input).
 *   2. Vocabularies (`inputType: 'vocabulary'`) cover the same
 *      "pick from a constrained list of values" use case with a
 *      centrally-managed `vocabulary_entry` table, per-record approval
 *      workflow, and locale-aware labels. 13 vocabulary types are
 *      already wired (`VOCABULARY_TYPE_CONFIG`).
 *   3. Empirical: zero subfields in personal.json or any legacy TS
 *      config use `select`/`combobox` — only test fixtures do.
 *
 * The renderer still honours legacy `select`/`combobox` configs that
 * were authored by hand (raw JSON mode), so hiding them from the
 * dropdown is fully backward compatible — only the "create new field"
 * flow is restricted.
 */
export var OFFERED_INPUT_TYPES = INPUT_TYPES.filter(function (t) { return t !== 'select' && t !== 'combobox'; });
/**
 * All vocabulary-type keys from `VOCABULARY_TYPE_CONFIG`. Sorted for a
 * stable dropdown order in the property panel.
 */
export var VOCABULARY_TYPES = Object.keys(VOCABULARY_TYPE_CONFIG).sort();
